// src/components/StockTicker.jsx
import React, { useEffect, useState } from "react";

const StockTicker = ({ holdings }) => {
  const [tickerItems, setTickerItems] = useState([]);

  useEffect(() => {
    if (holdings && holdings.length > 0) {
      // Create ticker items from holdings
      const items = holdings.map(holding => ({
        symbol: holding.symbol,
        price: holding.price,
        change: holding.unrealizedPLPercent,
        name: holding.name
      }));
      
      // Duplicate items for seamless scrolling
      setTickerItems([...items, ...items, ...items]);
    }
  }, [holdings]);

  if (!tickerItems.length) {
    return null;
  }

  return (
    <div className="relative overflow-hidden bg-gray-900 border-y border-gray-800 py-2">
      <div className="flex animate-scroll whitespace-nowrap">
        {tickerItems.map((item, index) => (
          <div
            key={`${item.symbol}-${index}`}
            className="inline-flex items-center mx-4 sm:mx-6 text-sm"
          >
            <span className="font-bold text-white mr-2">
              {item.symbol}
            </span>
            <span className="text-gray-400 mr-2">
              ${item.price.toFixed(2)}
            </span>
            <span
              className={`font-semibold ${
                item.change >= 0 ? "text-green-400" : "text-red-400"
              }`}
            >
              {item.change >= 0 ? "+" : ""}
              {item.change.toFixed(2)}%
            </span>
            <span className="mx-3 text-gray-700">|</span>
          </div>
        ))}
      </div>

      {/* Custom CSS for animation is added in index.css */}
    </div>
  );
};

export default StockTicker;
